var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",class:[
    _vm.$mq,
    _vm.$route.name,
    _vm.themeVariant
  ],style:(_vm.cssProps),attrs:{"id":"app"}},[_c('vue-progress-bar'),(['mobile', 'tablet'].includes(_vm.$mq))?_c('div',{staticClass:"dashGround"}):_vm._e(),(_vm.env === 'local')?_c('div',{staticClass:"mq"},[_vm._v(" "+_vm._s(_vm.$mq)+" ")]):_vm._e(),_c('transition',{attrs:{"name":"el-fade-in","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }